import { Search, X } from "lucide-react";
import { Button } from "@/v2/components/ui/button";
import { Input } from "@/v2/components/ui/input";
import {
	Popover,
	PopoverContent,
	PopoverTrigger,
} from "@/v2/components/ui/popover";
import { cn } from "@/v2/lib/utils";

export interface SearchBarProps {
	value: string;
	onChange: (next: string) => void;
	onClear: () => void;
	className?: string;
}

export function SearchBar({
	value,
	onChange,
	onClear,
	className,
}: SearchBarProps) {
	const hasQuery = value !== "";

	return (
		<Popover>
			<PopoverTrigger asChild>
				<Button
					variant="outline"
					size="icon"
					aria-label="Search entries"
					className={cn(
						"relative",
						hasQuery &&
							"border-ring text-ring hover:border-ring hover:text-ring",
						className,
					)}
				>
					<Search />
					{hasQuery && (
						<span className="absolute right-1 top-1 size-1.5 rounded-full bg-ring" />
					)}
				</Button>
			</PopoverTrigger>
			{/* Radix auto-focuses the first focusable child (the input) on open. */}
			<PopoverContent align="center" className="w-72 p-2">
				<div className="relative">
					<Search className="pointer-events-none absolute left-2.5 top-1/2 size-4 -translate-y-1/2 text-muted-foreground" />
					<Input
						type="search"
						value={value}
						onChange={(e) => onChange(e.target.value)}
						placeholder="Search entries…"
						className="h-10 pl-8 pr-8 text-sm [&::-webkit-search-cancel-button]:hidden"
						aria-label="Search entries"
					/>
					{value && (
						<Button
							variant="ghost"
							size="icon"
							onClick={onClear}
							aria-label="Clear search"
							className="absolute right-0.5 top-1/2 size-9 -translate-y-1/2 hover:bg-transparent"
						>
							<X className="size-4 text-muted-foreground" />
						</Button>
					)}
				</div>
			</PopoverContent>
		</Popover>
	);
}
